<template>
  <div class="w-chart">
    <div class="w-toolbar">
      <div class="w-chips">
        <span class="chip"><b>{{ fmt(total) }}</b> customers</span>
        <span class="chip up" v-if="lastYear"><i class="fas fa-user-plus"></i> {{ fmt(lastYear) }} joined in 12 months</span>
      </div>
    </div>
    <div class="w-plot">
      <apexchart :key="chartKey" v-if="rows.length" type="line" height="100%" :options="options" :series="series"/>
      <div v-else class="w-empty"><i class="fas fa-users"></i>{{ stats.customersTrend ? 'No customers yet' : 'Loading…' }}</div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { apexBase, compact, fmt, monthLabel, palette, themeState } from '../theme';

export default {
  name: 'Customers',
  components: { apexchart: VueApexCharts },
  props: { stats: { type: Object, required: true } },
  computed: {
    // a theme or data change re-creates the chart: ApexCharts does not always redraw mixed charts on update
    chartKey() { return `${themeState.tick}:${JSON.stringify(this.series)}`; },
    rows() { return this.stats.customersTrend || []; },
    total() { return this.rows.length ? this.rows[this.rows.length - 1].cumulativeCustomers : 0; },
    lastYear() {
      const limit = new Date();
      limit.setUTCMonth(limit.getUTCMonth() - 12);
      const key = `${limit.getUTCFullYear()}-${String(limit.getUTCMonth() + 1).padStart(2, '0')}`;
      return this.rows.filter((r) => r.month > key).reduce((a, r) => a + (Number(r.newCustomers) || 0), 0);
    },
    series() {
      return [
        { name: 'Customers', type: 'area', data: this.rows.map((r) => r.cumulativeCustomers) },
        { name: 'New that month', type: 'column', data: this.rows.map((r) => Number(r.newCustomers) || 0) },
      ];
    },
    options() {
      void themeState.tick;
      const p = palette();
      return apexBase({
        colors: [p.violet, p.sky],
        labels: this.rows.map((r) => monthLabel(r.month)),
        stroke: { width: [3, 0] },
        fill: { type: ['gradient', 'solid'], opacity: [1, 0.6], gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.02, stops: [0, 100] } },
        plotOptions: { bar: { columnWidth: '50%', borderRadius: 3 } },
        xaxis: { tickAmount: 8, labels: { rotate: 0, hideOverlappingLabels: true } },
        yaxis: [{ labels: { formatter: (v) => compact(v) } }, { opposite: true, labels: { formatter: (v) => compact(v) } }],
        legend: { position: 'top', horizontalAlign: 'right' },
        tooltip: { shared: true, intersect: false },
      });
    }
  },
  methods: { fmt }
};
</script>

<style scoped lang="scss">
@import '../widgets.scss';
</style>
